import { createFileRoute } from "@tanstack/react-router";
import TermsPage from "@/pages/TermsPage";
import { pageHead } from "@/lib/site";

export const Route = createFileRoute("/terms-and-conditions")({
  head: () =>
    pageHead(
      "Terms & Conditions | Scotty's Land Specialist",
      "Terms and Conditions for Scotty's Land Specialist LLC, covering use of our website and property services.",
      "/terms-and-conditions",
    ),
  component: TermsPage,
});
